import React from 'react';
import { Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Clear } from '@mui/icons-material';

const FieldDate = ({ control, name, label, rules, setValue, disabled, disableClear }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        ...rules,
        pattern: {
          value: /(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0,1,2])\/(19|20)\d{2}/,
          message: 'Invalid date format (DD/MM/YYYY)',
        },
      }}
      render={({ field, fieldState }) => (
        <InputMask
          {...field}
          mask="99/99/9999" // DD/MM/YYYY format
          maskChar="_"
          disabled={disabled}
        >
          {(inputProps) => (
            <TextField
              {...inputProps}
              label={label}
              variant="filled"
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              disabled={disabled}
              slotProps={{
                input: {
                  endAdornment:
                    field.value && !disableClear ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setValue(field.name, '')}
                          edge="end"
                          size={'small'}
                          disabled={disabled}
                        >
                          <Clear />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                },
              }}
            />
          )}
        </InputMask>
      )}
    />
  );
};

export default FieldDate;
